<template>
  <div>
    <div v-if="loading" class="text-center py-4 text-muted">
      <i class="fe fe-loader" style="font-size:1.5rem; opacity:0.4;"></i>
      <p class="mt-2 mb-0 small">Loading chart…</p>
    </div>
    <div v-else-if="!chartSeries[0].data.length" class="text-center py-4 text-muted">
      <i class="fe fe-inbox" style="font-size:2rem; opacity:0.3;"></i>
      <p class="mt-2 mb-0 small">No data — apply filters and click Get Statistics.</p>
    </div>
    <apexchart v-else type="bar" :height="height" :options="chartOptions" :series="chartSeries" />
  </div>
</template>

<script>
import VueApexCharts from "vue-apexcharts";

function chartToolbar(filename) {
  return {
    show: true,
    tools: { download: true, selection: false, zoom: false, zoomin: false, zoomout: false, pan: false, reset: false },
    export: { csv: { filename: filename }, svg: { filename: filename }, png: { filename: filename } },
  };
}

export default {
  components: { apexchart: VueApexCharts },
  props: {
    byDate:   { type: Array,            default: function () { return []; } },
    loading:  { type: Boolean,          default: false },
    height:   { type: [Number, String], default: 280 },
    filename: { type: String,           default: "authorization-requests-by-date" },
  },
  computed: {
    chartOptions() {
      return {
        chart: { type: "bar", toolbar: chartToolbar(this.filename), fontFamily: "inherit" },
        plotOptions: { bar: { borderRadius: 3, columnWidth: "60%" } },
        dataLabels: { enabled: true },
        xaxis: {
          categories: this.byDate.map(function (d) { return d.date; }),
          labels: { style: { fontSize: "10px", colors: "#64748b" }, rotate: -30 },
        },
        yaxis: { labels: { style: { fontSize: "11px", colors: "#64748b" } } },
        colors: ["#2563eb", "#059669", "#e11d48"],
        legend: { position: "top" },
        grid: { borderColor: "#f1f5f9", strokeDashArray: 4 },
        tooltip: { y: { formatter: function (v) { return v.toLocaleString(); } } },
      };
    },
    chartSeries() {
      return [
        { name: "Total",    data: this.byDate.map(function (d) { return Number(d.total    || 0); }) },
        { name: "Approved", data: this.byDate.map(function (d) { return Number(d.approved || 0); }) },
        { name: "Rejected", data: this.byDate.map(function (d) { return Number(d.rejected || 0); }) },
      ];
    },
  },
};
</script>
